import { render } from "./BackgroundCover.vue?vue&type=template&id=c0f14ab4"
import script from "./BackgroundCover.vue?vue&type=script&lang=js"
export * from "./BackgroundCover.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__